export default __webpack_public_path__ + "static/media/building-1.b127fe00.png";